import { render, staticRenderFns } from "./ServiceRemoteAccess.vue?vue&type=template&id=4a146671&scoped=true&"
import script from "./ServiceRemoteAccess.vue?vue&type=script&lang=js&"
export * from "./ServiceRemoteAccess.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRemoteAccess.vue?vue&type=style&index=0&id=4a146671&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a146671",
  null
  
)

export default component.exports